// src/components/Sections2/PTGCModal.jsx
import React, {useState, useRef, useEffect} from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Modal from "react-modal";
import Leaderboard from "./leaderboard";

Modal.setAppElement("#root");

const PTGCModal = ({ isOpen, onClose, activeTab, setActiveTab }) => {
  const handleModalOpen = () => {
    document.body.style.overflow = "hidden"; // prevent scroll when modal open
  };

  const handleModalClose = () => {
    document.body.style.overflow = "auto";
    onClose();
  };

const [showInfo1, setShowInfo1] = useState(false);
const [showInfo2, setShowInfo2] = useState(false);
const [showInfo3, setShowInfo3] = useState(false);
const [showInfo4, setShowInfo4] = useState(false);
const [showInfo5, setShowInfo5] = useState(false);

const [showVideoInfo1, setShowVideoInfo1] = useState(false);
const [showVideoInfo2, setShowVideoInfo2] = useState(false);
const [showVideoInfo3, setShowVideoInfo3] = useState(false);
const [showVideoInfo4, setShowVideoInfo4] = useState(false);

const videoRef1 = useRef(null);
const videoRef2 = useRef(null);
const videoRef3 = useRef(null);
const videoRef4 = useRef(null);

const handleVideoToggle1 = () => {
  setShowVideoInfo1((prev) => {
    const newState = !prev;
    if (!prev && videoRef1.current) {
      setTimeout(() => videoRef1.current.play(), 300);
    }
    return newState;
  });
};

const handleVideoToggle2 = () => {
  setShowVideoInfo2((prev) => {
    const newState = !prev;
    if (!prev && videoRef2.current) {
      setTimeout(() => videoRef2.current.play(), 300);
    }
    return newState;
  });
};

const handleVideoToggle3 = () => {
  setShowVideoInfo3((prev) => {
    const newState = !prev;
    if (!prev && videoRef3.current) {
      setTimeout(() => videoRef3.current.play(), 300);
    }
    return newState;
  });
};

const handleVideoToggle4 = () => {
  setShowVideoInfo4((prev) => {
    const newState = !prev;
    if (!prev && videoRef4.current) {
      setTimeout(() => videoRef4.current.play(), 300);
    }
    return newState;
  });
};
useEffect(() => {
  if (showVideoInfo1 && videoRef1.current) {
    videoRef1.current.play().catch(err => console.log("Autoplay blocked:", err));
  }
}, [showVideoInfo1]);

useEffect(() => {
  if (showVideoInfo2 && videoRef2.current) {
    videoRef2.current.play().catch(err => console.log("Autoplay blocked:", err));
  }
}, [showVideoInfo2]);

useEffect(() => {
  if (showVideoInfo3 && videoRef3.current) {
    videoRef3.current.play().catch(err => console.log("Autoplay blocked:", err));
  }
}, [showVideoInfo3]);

useEffect(() => {
  if (showVideoInfo4 && videoRef4.current) {
    videoRef4.current.play().catch(err => console.log("Autoplay blocked:", err));
  }
}, [showVideoInfo4]);
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleModalClose}
      onAfterOpen={handleModalOpen}
      contentLabel="PTGC Modal"
      className="My__Overlay"
      overlayClassName="ReactModal__Overlay"
    >
      <div className="My__OverlayIn">
        <div className="UFOSEC popupcenter">
          <button
            className="nobg closepopup d-flex align-items-center gap-1"
            onClick={handleModalClose}
          >
            <span className="underline">Close</span>
            <img src="./images/XCircle.svg" className="img-fluid" alt="close" />
          </button>
          <div className="container">
          <div className="text-center">
            <h2 className="mb-0 mt-2 w-100 good_times goldFont">
              UFO Onboarding
            </h2>
          </div>

          {/* Tabs Navigation */}
          <div className="d-flex justify-content-center ">
            <div className="tabs nav nav-pills mb-1 gap-1 mt-4 text-center">
              {/*<button
                className={`nav-link ${activeTab === "leaderboard" ? "active" : ""}`}
                onClick={() => setActiveTab("leaderboard")}
              >
                Leaderboard
              </button>*/}
              <button
                className={`nav-link ${activeTab === "help" ? "active" : ""}`}
                onClick={() => setActiveTab("help")}
              >
                Need help getting UFO?
              </button>
              <button
                className={`nav-link ${activeTab === "videos" ? "active" : ""}`}
                onClick={() => setActiveTab("videos")}
              >
                Videos
              </button>
            </div>
          </div>

          {/* Tabs Content */}
          <div className="tabContent mt-4">
            {activeTab === "leaderboard" && (
              <div className="tab-pane">
                  <Leaderboard />
              </div>
            )}
            {activeTab === "help" && (
              <div className="HelpTab tab-pane">

                <div className="tokenNG mb-4  pb-0 relative overHide" >
                  <div className="shapT1"></div>
                  <div className="shapT2"></div>
                  <div className="p-3">
                    <div className="row align-items-center relative">
                      <div className="col-lg-6">
                        
                        <video
                          width="100%"
                          height="350"
                          controls
                          loop
                          style={{ background: '#000', borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
                        >
                          <source src="https://stats.goptgc.com/videos/ptgcpulsechain.MP4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>

                      <div className="col-lg-6">
                        <div className="">
                          <h3 className="good_times goldFont">How to get onto Pulsechain </h3>
                          <p>To get onto PulseChain, first add the PulseChain network to your wallet (like MetaMask) using its RPC details. Then, bridge your assets from Ethereum to PulseChain using the PulseChain Bridge at <a className="goldFont" href="https://bridge.pulsechain.com" target="_blank">https://bridge.pulsechain.com</a></p>
                          
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="bSRIN overHide subcontent">
                  <div className="boxes2 p-0">
                    <div className="py-0 px-0">
                      <div className="row m-0">                       
                        <div className="col-lg-6 p-0  mobBorderBottomAdd991 borderBottom borderRight">
                          <div className="p-3">
                          <h2 className=" mb-0 speacialH2 "><span className="">Step 01:</span></h2>
                          <h3 className="mb-0 good_times goldFont">PREPARE YOUR WALLET</h3>
                          <p>
                            <a className="goldFont" href="https://internetmoney.io/" target="_blank">Internet Money</a>  or <a className="goldFont" href="https://metamask.io/download" target="_blank">MetaMask</a>. 
                          </p>

                          <div className="bottomSliderBtn mt-0">
                            <div className="d-flex gap-2 align-items-center">

                               <button
                                className="borderbtn mybtn"
                                style={{ paddingLeft: "17px" }}
                                onClick={handleVideoToggle1}
                              >
                                <span>{showVideoInfo1 ? "Hide Video" : "Watch Video"}</span>{" "}
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>
                              <button className="borderbtn mybtn" onClick={() => setShowInfo1(!showInfo1)} style={{ paddingLeft: "17px" }}>
                                <span>{showInfo1  ? "Hide Info" : "More Info"}</span>{" "}
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>
                            </div>
                          </div>
                          {showVideoInfo1 && (
                            <div
                              className="extraVideoContent mt-4"
                              style={{
                                overflow: "hidden",
                                transition: "max-height 0.5s ease",
                                maxHeight: showVideoInfo1 ? "500px" : "0px",
                              }}
                            >
                              <div className="">
                                <div className="">
                                  <video
                                    ref={videoRef1}
                                    width="100%"
                                    height="346"
                                    controls
                                    loop
                                    muted   // ADD THIS
                                    style={{ background: "#000", borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
                                  >
                                    <source src="https://stats.goptgc.com/videos/preparing_wallet.MP4" type="video/mp4" />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              </div>
                            </div>
                          )}
                          <div
                            className="extraContent"
                            style={{
                              display: showInfo1  ? "block" : "none",
                              overflow: "hidden",
                              transition: "all 0.5s ease",
                            }}
                          >
                            <div className="">
                              <div className="fInter">
                                <p>You must have a supported wallet installed on your browser or mobile device.</p>
                                <ol style={{paddingLeft:'15px'}}>
                                  <li>
                                    <b>MetaMask</b> – available for Chrome, Firefox, Brave, Edge, iOS, Android
                                  </li>
                                  <li>
                                    <b>Internet Money Wallet (IM Wallet)</b> – available for Chrome extension and mobile apps
                                  </li>
                                </ol>
                                <p>Download only from official sources such as the Chrome Web Store, Google Play, or the Apple App Store.</p>
                              </div>

                              <div className="networkBox d-grid gap-2">
                                <div><span style={{ color: "rgba(255,255,255,0.6)" }}>Network Name:</span> PulseChain</div>
                                <div><span style={{ color: "rgba(255,255,255,0.6)" }}>RPC URL:</span> https://rpc.pulsechain.com</div>
                                <div><span style={{ color: "rgba(255,255,255,0.6)" }}>Chain ID:</span> 369</div>
                                <div><span style={{ color: "rgba(255,255,255,0.6)" }}>Currency Symbol:</span> PLS</div>
                                <div><span style={{ color: "rgba(255,255,255,0.6)" }}>Block Explorer URL:</span> <span className="wordbreak" >https://ipfs.scan.pulsechain.com</span></div>
                              </div>
                            </div>
                          </div>
                        </div>                        </div>
                        <div className="col-lg-6 p-0  mobBorderBottomAdd991 borderBottom borderRight">
                          <div className="p-3">
                          
                          <h2 className=" mb-0 speacialH2 "><span className="">Step 02:</span></h2>
                          <h3 className="mb-0 good_times goldFont">GET CRYPTO</h3>
                          <p>If you don’t have crypto yet, buy ETH or USDC on an exchange like <a className="goldFont" href="https://www.coinbase.com/" target="_blank">Coinbase</a> or <a className="goldFont" href="https://www.kraken.com/" target="_blank">Kraken</a>.
                          </p>

                          <div className="bottomSliderBtn mt-0">
                            <div className="d-flex gap-2 align-items-center">
                               <button
                                className="borderbtn mybtn"
                                style={{ paddingLeft: "17px" }}
                                onClick={handleVideoToggle2}
                              >
                                <span>{showVideoInfo2 ? "Hide Video" : "Watch Video"}</span>{" "}
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>

                              <button
                                className="borderbtn mybtn  text-white"
                                onClick={() => setShowInfo2(!showInfo2)}
                              >
                                <span>{showInfo2 ? "Hide Info" : "More Info"}</span>
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>
                            </div>
                          </div>
                          {showVideoInfo2 && (
                            <div
                              className="extraVideoContent mt-4"
                              style={{
                                overflow: "hidden",
                                transition: "max-height 0.5s ease",
                                maxHeight: showVideoInfo2 ? "500px" : "0px",
                              }}
                            >
                              <div className="">
                                <div className="">
                                  <video
                                    ref={videoRef2}
                                    width="100%"
                                    height="346"
                                    controls
                                    loop
                                    muted   // ADD THIS
                                    style={{ background: "#000", borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
                                  >
                                    <source src="https://stats.goptgc.com/videos/get_crypto.MP4" type="video/mp4" />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              </div>
                            </div>
                          )}
                          <div
                            className="extraContent"
                            style={{
                              display: showInfo2 ? "block" : "none",
                              overflow: "hidden",
                              transition: "all 0.5s ease",
                            }}
                          ><div className="content fInter">
                            <div >
                              <h5 className="mb-1 good_times ">Buy ETH or USDC</h5>
                              <p className="mb-1">You can buy popular cryptocurrencies like ETH (Ethereum) or USDC (USD Coin) on major exchanges such as:</p>
                              <ul style={{paddingLeft:'15px'}}>
                                <li><a className="goldFont" href="https://www.coinbase.com/" target="_blank">Coinbase</a></li>
                                <li><a className="goldFont" href="https://www.kraken.com/" target="_blank">Kraken</a></li>
                                <li>Binance</li>
                              </ul>
                              <h5 className="mb-1 good_times ">How it works</h5>
                              <ol style={{paddingLeft:'15px'}}>
                                <li>Create an account on a cryptocurrency exchange.</li>
                                <li>Complete identity verification (KYC).</li>
                                <li>Add a payment method (bank transfer, debit card, etc.).</li>
                                <li>Buy ETH or USDC using your local currency.</li>
                              </ol>
                              <h5 className="mb-1 good_times ">Send crypto to your wallet</h5>
                              <p className="mb-1">Once purchased:</p>
                              <ol style={{paddingLeft:'15px'}}>
                                <li>Go to Withdraw / Send in the exchange.</li>
                                <li>Paste your wallet address (from MetaMask or Internet Money).</li>
                                <li>Select ETH / USDC.</li>
                                <li>Enter amount.</li>
                                <li>Confirm withdrawal.</li>
                              </ol>
                                
                            </div>
                          </div>
                          </div>
                        </div>
                        </div>
                        <div className="col-lg-6 p-0  mobBorderBottomAdd991 borderBottom borderRight">
                          <div className="p-3">
                          
                          <h2 className=" mb-0 speacialH2 "><span className="">Step 03:</span></h2>
                          <h3 className="mb-0 good_times goldFont">BUY PLS</h3>
                          <p>You can use <a className="goldFont" href="https://libertyswap.finance/" target="_blank">Liberty Swap</a> to buy PLS, or bridge in using the <a className="goldFont" href="https://bridge.pulsechain.com" target="_blank">PulseChain Bridge</a>.
                          </p>

                          <div className="bottomSliderBtn mt-0">
                            <div className="d-flex gap-2 align-items-center">
                              <button className="borderbtn mybtn" style={{ paddingLeft: "17px" }} onClick={handleVideoToggle3}>
                                <span>Watch Video</span>{" "}
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>

                              <button
                                className="borderbtn mybtn  text-white"
                                onClick={() => setShowInfo3(!showInfo3)}
                              >
                                <span>{showInfo3 ? "Hide Info" : "More Info"}</span>
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>
                            </div>
                          </div>
                          {showVideoInfo3 && (
                            <div
                              className="extraVideoContent mt-4"
                              style={{
                                overflow: "hidden",
                                transition: "max-height 0.5s ease",
                                maxHeight: showVideoInfo3 ? "500px" : "0px",
                              }}
                            >
                              <div className="">
                                <div className="">
                                  <video
                                    ref={videoRef3}
                                    width="100%"
                                    height="346"
                                    controls
                                    loop
                                    muted   // ADD THIS
                                    style={{ background: "#000", borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
                                  >
                                    <source src="https://stats.goptgc.com/videos/buy_pls.MP4" type="video/mp4" />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              </div>
                            </div>
                          )}
                          <div
                            className="extraContent"
                            style={{
                              display: showInfo3 ? "block" : "none",
                              overflow: "hidden",
                              transition: "all 0.5s ease",
                            }}
                          ><div className="content fInter">
                            <div >
                              <h6 className="mb-1 good_times ">1. Buy ETH or USDC</h6>
                              <p className="mb-3">From an exchange like <a className="goldFont" href="https://www.coinbase.com/" target="_blank">Coinbase</a>, <a className="goldFont" href="https://www.kraken.com/" target="_blank">Kraken</a>, Binance, etc.</p>
                              <h6 className="mb-1 good_times ">2. Send to your wallet</h6>
                              <p className="mb-3">Transfer to MetaMask / Internet Money (address starts with 0x).</p>
                              <h6 className="mb-1 good_times ">3. Bridge to PulseChain</h6>
                              <p className="mb-3">Move your crypto to <a className="goldFont" href="https://bridge.pulsechain.com" target="_blank">PulseChain</a> using a bridge.</p>
                              <h6 className="mb-1 good_times ">4. Swap to PLS</h6>
                              <p className="mb-1">Use a DEX on PulseChain and swap ETH/USDC → PLS.</p>
                            </div>
                          </div>
                          </div>
                        </div>
                        </div>
                        <div className="col-lg-6 p-0  mobBorderBottomAdd991 borderBottom borderRight">
                          <div className="p-3">
                          
                          <h2 className=" mb-0 speacialH2 "><span className="">Step 04:</span></h2>
                          <h3 className="mb-0 good_times goldFont">SWAP PLS → UFO  </h3>
                          <p>Swap your PLS for UFO on <a className="goldFont" href="https://app.pulsex.com/" target="_blank">PulseX</a> or swap on our <Link className="goldFont" to="/ptgc-onboarding">onboarding page</Link>.
                          </p>

                          <div className="bottomSliderBtn mt-0">
                            <div className="d-flex gap-2 align-items-center">
                              <button className="borderbtn mybtn" style={{ paddingLeft: "17px" }} onClick={handleVideoToggle4}>
                                <span>Watch Video</span>{" "}
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>

                              <button
                                className="borderbtn mybtn  text-white"
                                onClick={() => setShowInfo4(!showInfo4)}
                              >
                                <span>{showInfo4 ? "Hide Info" : "More Info"}</span>
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>
                            </div>
                          </div>
                          {showVideoInfo4 && (
                            <div
                              className="extraVideoContent mt-4"
                              style={{
                                overflow: "hidden",
                                transition: "max-height 0.5s ease",
                                maxHeight: showVideoInfo4 ? "500px" : "0px",
                              }}
                            >
                              <div className="">
                                <div className="">
                                  <video
                                    ref={videoRef4}
                                    width="100%"
                                    height="346"
                                    controls
                                    loop
                                    muted   // ADD THIS
                                    style={{ background: "#000", borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
                                  >
                                    <source src="https://stats.goptgc.com/videos/swap_pls_to_ptgc.MP4" type="video/mp4" />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              </div>
                            </div>
                          )}
                          <div
                            className="extraContent"
                            style={{
                              display: showInfo4 ? "block" : "none",
                              overflow: "hidden",
                              transition: "all 0.5s ease",
                            }}
                          ><div className="content fInter">
                            <div >
                              <h6 className="mb-1 good_times ">1. Open your wallet</h6>
                              <p className="mb-3">Connect MetaMask / Internet Money to <a className="goldFont" href="https://pulsechain.com/" target="_blank">PulseChain</a> network.</p>

                              <h6 className="mb-1 good_times ">2. Go to a DEX on PulseChain</h6>
                              <p className="mb-3">Example: PulseX (most common).</p>

                              <h6 className="mb-1 good_times ">3. Select tokens</h6>
                              <ul style={{paddingLeft:'15px'}}>
                                <li>From: PLS</li>
                                <li>To: UFO (import token if not visible using contract address)</li>
                              </ul>

                              {/* New line item added for slippage */}
                              <h6 className="mb-1 good_times">4. Set Slippage</h6>
                              <p className="mb-3">If using PulseX, set slippage to <strong>7%</strong> for successful swapping.</p>

                              <h6 className="mb-1 good_times ">5. Enter amount & Confirm</h6>
                              <p className="mb-1">Review price → Gas fee → Swap → Confirm.</p>

                              <h6 className="mb-1 good_times ">6. Done</h6>
                              <p className="mb-1">UFO will appear in your wallet (add token if not shown).</p>

                            </div>
                          </div>
                          </div>
                        </div>
                        </div>
                        <div className="col-lg-12 p-0    ">
                          <div className="p-3">
                          
                          <h2 className=" mb-0 speacialH2 "><span className="">Step 05:</span></h2>
                          <h3 className="mb-0 good_times goldFont">STAKE & LOCK YOUR UFO</h3>
                          <p>Earn over 100% additional APY by Staking and Locking your tokens.
                          </p>

                          <div className="bottomSliderBtn mt-0">
                            <div className="d-flex gap-2 align-items-center">
                              <button className="borderbtn mybtn" style={{ paddingLeft: "17px" }} onClick={() => setActiveTab("videos")}>
                                <span>Watch More Videos</span>{" "}
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>

                              <button
                                className="borderbtn mybtn  text-white"
                                onClick={() => setShowInfo5(!showInfo5)}
                              >
                                <span>{showInfo5 ? "Hide Info" : "More Info"}</span>
                                <img src="./images/circle_arrow.svg" className="img-fluid" style={{ width: "25px" }} />
                              </button>
                            </div>
                          </div>
                          <div
                            className="extraContent"
                            style={{
                              display: showInfo5 ? "block" : "none",
                              overflow: "hidden",
                              transition: "all 0.5s ease",
                            }}
                          ><div className="content fInter">
                            <div >
                              <h6 className="mb-1 good_times ">1. How to Stake</h6>
                              <ol style={{paddingLeft:'15px'}}>
                                <li>Connect your wallet (MetaMask / Internet Money) to the staking platform.</li>
                                <li>Choose Stake UFO.</li>
                                <li>Enter the amount of UFO to stake.</li>
                                <li>Click Approve → then Stake.</li>
                              </ol>
                              <h6 className="mb-1 good_times ">2. How to Lock</h6>
                              <ol style={{paddingLeft:'15px'}}>
                                <li>After staking, select Lock Tokens.</li>
                                <li>Choose your Lock duration (longer lock = higher rewards).</li>
                                <li>Confirm transaction.</li>
                              </ol>
                              <h6 className="mb-1 good_times ">3. Rewards</h6>
                              <ol style={{paddingLeft:'15px'}}>
                                <li>Earn extra APY based on stake + lock time.</li>
                                <li>Rewards can be claimed anytime according to platform rules.</li>
                              </ol>
                            </div>
                          </div>
                          </div>
                        </div>
                      </div></div>
                    </div>
                  </div>
                </div>
                {/*<div className="mt-4 bSRIN overHide subcontent relative overHide">
                  <div className="shapT1"></div>
                  <div className="shapT2"></div>
                  <div className="boxes2 py-5 p-3 text-center">
                    <h2 className="mb-2 speacialH2">Ready to start using PulseChain?</h2>

                    <p>Buy with a Bank Account</p>
                    <div className="aaaHere d-flex gap-3 justify-content-center">
                      <a className="aa normalbtn" href="https://0xcoast.com" target="_blank" >0xCoast</a>
                      <a className="aa normalbtn" href="https://app.rampnow.io" target="_blank" >Rampnow</a>
                    </div>
                    <div className="aaaHere d-flex gap-3 justify-content-center mt-3">
                      <a className="aa normalbtn" href="https://libertyswap.finance/" target="_blank" >Cross-chain Swap</a>
                    </div>

                    <div className=" d-flex justify-content-center mt-4">
                      <div className="circleBoxes d-flex justify-content-center ">
                        <a href="https://gibs.finance/#/onboard" target="_blank">
                          <div className="snCircle d-flex align-items-center justify-content-center">
                            <img className="bridge-bg" src="./images/bg-BBRxN9g0.jpg" />
                            <div className="circleContent">
                              <p className="mb-0">Bridge</p>
                            </div>
                          </div>
                        </a>
                        <a href="https://ipfs.app.pulsex.com" target="_blank">
                          <div className="snCircle d-flex align-items-center justify-content-center">
                            <img className="bridge-bg" src="./images/bg-BBRxN9g0.jpg" />
                            <div className="circleContent">
                              <p className="mb-0">
                              <img className="img-fluid" src="./images/swap.svg" /> Swap</p>
                            </div>
                          </div>
                        </a>
                        <a href="https://pump.tires/" target="_blank">
                          <div className="snCircle d-flex align-items-center justify-content-center">
                            <img className="bridge-bg" src="./images/bg-BBRxN9g0.jpg" />
                            <div className="circleContent">
                              <p className="mb-0">Launch</p>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className=" d-flex justify-content-center mt-4">
                      <div className="snCircleMine circleBoxes d-flex justify-content-center ">
                        <a href="https://pump.tires/" target="_blank">
                          <div className=" snCircle d-flex align-items-center justify-content-center">
                            <img className="bridge-bg" src="./images/bg-BBRxN9g0.jpg" />
                            <div className="circleContent">
                              <p className="mb-0">
                              <svg width="32px" height="28px" viewBox="0 0 32 28" xmlns="http://www.w3.org/2000/svg">
                                <title>HEX</title>
                                <defs>
                                  <linearGradient x1="75%" y1="12.1591473%" x2="25.0657%" y2="87.9514179%" id="linearGradient-3">
                                    <stop stopColor="#FF00FF" offset="0%" />
                                    <stop stopColor="#FF3333" offset="50%" />
                                    <stop stopColor="#FFDD00" offset="100%" />
                                  </linearGradient>
                                </defs>
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                  <path
                                    d="M7.52331265,27.3560999 L5.35758866,23.6210254 C5.29033425,23.4825897 5.29033425,23.3211092 5.35758866,23.1826736 L7.76382201,19.0330953 C7.84932654,18.9027181 7.99188719,18.8205335 8.14795305,18.8116482 L12.95814,18.8116482 C13.1144554,18.8207167 13.2572867,18.9028137 13.3434109,19.0330953 L15.7485045,23.1826736 C15.8181151,23.3221601 15.8181151,23.4860813 15.7485045,23.6255678 L13.3365718,27.7728747 C13.2504282,27.8996227 13.1112642,27.9806397 12.95814,27.9931862 L8.63695073,27.9931862 C8.18669386,27.964259 7.77535594,27.7289422 7.52331265,27.3560999 Z M23.1393225,18.8150552 L18.3519326,10.5476963 C18.2336364,10.3708787 18.0393136,10.2591691 17.8264596,10.2456197 L8.24028128,10.2456197 C8.02742736,10.2591691 7.83310452,10.3708787 7.71480824,10.5476963 L2.92171909,18.8195976 C2.82720855,19.0099756 2.82720855,19.2333729 2.92171909,19.4237508 L4.33171939,21.8494484 L6.78924621,17.6112914 C6.92386588,17.4067351 7.1472173,17.2771756 7.39222936,17.2615185 L13.7070246,17.2615185 C13.9538392,17.2752404 14.1793906,17.4050944 14.3145671,17.6112914 L17.4731046,23.0622972 C17.5848257,23.2821964 17.5848257,23.5419438 17.4731046,23.761843 L15.0155778,28 L17.82304,28 C18.0364733,27.9874162 18.2313469,27.874969 18.348513,27.6967878 L23.1393225,19.4260221 C23.236104,19.2337795 23.236104,19.0072978 23.1393225,18.8150552 Z M31.8364142,13.3447437 L24.4900504,0.652985075 C24.2361722,0.266876179 23.8128491,0.024368404 23.3501956,0 L8.64606957,0 C8.18341609,0.024368404 7.76009303,0.266876179 7.50621483,0.652985075 L0.156431498,13.3447437 C-0.0521438326,13.7544682 -0.0521438326,14.238718 0.156431498,14.6484425 L1.84227665,17.5567813 L6.72541434,9.12248539 C6.8928515,8.86800019 7.17163028,8.70784398 7.47657861,8.69094744 L18.5799036,8.69094744 C18.8845493,8.70783767 19.1629835,8.86803902 19.329928,9.12248539 L24.8798807,18.6992213 C25.0177971,18.9705068 25.0177971,19.2910118 24.8798807,19.5622972 L19.9921836,27.9931862 L23.354755,27.9931862 C23.8174085,27.9688179 24.2407316,27.7263101 24.4946098,27.3402011 L31.8443932,14.6495782 C32.0518689,14.2395924 32.0518689,13.7558651 31.8443932,13.3458793 L31.8364142,13.3447437 Z"
                                    fill="url(#linearGradient-3)"
                                    fillRule="nonzero"
                                  />
                                </g>
                              </svg> Mine</p>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>

                    <p className="mt-4">Add to your Wallet</p>
                    <div className="ssImga d-flex justify-content-center">
                      <a href="#">

                        <img className="img-fluid" src="./images/swap.svg" />
                      </a>


                      <a href="#" >

                        <img className="img-fluid" src="./coinimages/0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d.png" />
                      </a>
                      <a href="#" >
                        <svg width="32px" height="28px" viewBox="0 0 32 28" xmlns="http://www.w3.org/2000/svg">
                          <title>HEX</title>
                          <defs>
                            <linearGradient x1="75%" y1="12.1591473%" x2="25.0657%" y2="87.9514179%" id="linearGradient-3">
                              <stop stopColor="#FF00FF" offset="0%" />
                              <stop stopColor="#FF3333" offset="50%" />
                              <stop stopColor="#FFDD00" offset="100%" />
                            </linearGradient>
                          </defs>
                          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <path
                              d="M7.52331265,27.3560999 L5.35758866,23.6210254 C5.29033425,23.4825897 5.29033425,23.3211092 5.35758866,23.1826736 L7.76382201,19.0330953 C7.84932654,18.9027181 7.99188719,18.8205335 8.14795305,18.8116482 L12.95814,18.8116482 C13.1144554,18.8207167 13.2572867,18.9028137 13.3434109,19.0330953 L15.7485045,23.1826736 C15.8181151,23.3221601 15.8181151,23.4860813 15.7485045,23.6255678 L13.3365718,27.7728747 C13.2504282,27.8996227 13.1112642,27.9806397 12.95814,27.9931862 L8.63695073,27.9931862 C8.18669386,27.964259 7.77535594,27.7289422 7.52331265,27.3560999 Z M23.1393225,18.8150552 L18.3519326,10.5476963 C18.2336364,10.3708787 18.0393136,10.2591691 17.8264596,10.2456197 L8.24028128,10.2456197 C8.02742736,10.2591691 7.83310452,10.3708787 7.71480824,10.5476963 L2.92171909,18.8195976 C2.82720855,19.0099756 2.82720855,19.2333729 2.92171909,19.4237508 L4.33171939,21.8494484 L6.78924621,17.6112914 C6.92386588,17.4067351 7.1472173,17.2771756 7.39222936,17.2615185 L13.7070246,17.2615185 C13.9538392,17.2752404 14.1793906,17.4050944 14.3145671,17.6112914 L17.4731046,23.0622972 C17.5848257,23.2821964 17.5848257,23.5419438 17.4731046,23.761843 L15.0155778,28 L17.82304,28 C18.0364733,27.9874162 18.2313469,27.874969 18.348513,27.6967878 L23.1393225,19.4260221 C23.236104,19.2337795 23.236104,19.0072978 23.1393225,18.8150552 Z M31.8364142,13.3447437 L24.4900504,0.652985075 C24.2361722,0.266876179 23.8128491,0.024368404 23.3501956,0 L8.64606957,0 C8.18341609,0.024368404 7.76009303,0.266876179 7.50621483,0.652985075 L0.156431498,13.3447437 C-0.0521438326,13.7544682 -0.0521438326,14.238718 0.156431498,14.6484425 L1.84227665,17.5567813 L6.72541434,9.12248539 C6.8928515,8.86800019 7.17163028,8.70784398 7.47657861,8.69094744 L18.5799036,8.69094744 C18.8845493,8.70783767 19.1629835,8.86803902 19.329928,9.12248539 L24.8798807,18.6992213 C25.0177971,18.9705068 25.0177971,19.2910118 24.8798807,19.5622972 L19.9921836,27.9931862 L23.354755,27.9931862 C23.8174085,27.9688179 24.2407316,27.7263101 24.4946098,27.3402011 L31.8443932,14.6495782 C32.0518689,14.2395924 32.0518689,13.7558651 31.8443932,13.3458793 L31.8364142,13.3447437 Z"
                              fill="url(#linearGradient-3)"
                              fillRule="nonzero"
                            />
                          </g>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>*/}
              </div>
            )}
            {activeTab === "videos" && (
              <div className="tab-pane">
                
                <div className="tokenNG mb-4  relative overHide">
                  <div className="shapT1"></div>
                  <div className="shapT2"></div>
                  <div className="p-3">
                    <div className="row align-items-center relative">

                      <div className="col-lg-6">
                        <div className="">
                          <h3 className="good_times goldFont">UFO Basics </h3>
                          <p>Learn some of the key takeaways about the features that make UFO stand out against other tokens. In this video, we will briefly explain what makes UFO a success and how the code operates.</p>
                          
                        </div>
                      </div>
                      <div className="col-lg-6">
                        
                        <video
                          width="100%"
                          height="350"
                          controls
                          loop
                          style={{ background: '#000', borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
                        >
                          <source src="https://stats.goptgc.com/videos/ufobasic.MP4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>

                    </div>
                  </div>
                </div>
                
                <div className="tokenNG mb-4  relative overHide">
                  <div className="shapT1"></div>
                  <div className="shapT2"></div>
                  <div className="p-3">
                    <div className="row align-items-center relative">

                      <div className="col-lg-6">
                        
                        <video
                          width="100%"
                          height="350"
                          controls
                          loop
                          style={{ background: '#000', borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
                        >
                          <source src="https://stats.goptgc.com/videos/ufofarming.MOV" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>

                      <div className="col-lg-6">
                        <div className="">
                          <h3 className="good_times goldFont">UFO Farming</h3>
                          <p>Farm with UFO tokens to earn PLS rewards while retaining full self-custody of your LP tokens. Rewards are generated from network volume and volatility via the UFO web. By supporting liquidity, you'll receive PLS rewards, enhance the deflationary mechanisms of both PTGC and UFO, and strengthen the overall UFO ecosystem. Note: You can also simply hold UFO to earn UFO rewards.</p>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="tokenNG mb-4  relative overHide">
                  <div className="shapT1"></div>
                  <div className="shapT2"></div>
                  <div className="p-3">
                    <div className="row align-items-center relative">

                      <div className="col-lg-6">
                        <div className="">
                          <h3 className="good_times goldFont">UFO Stats </h3>
                          <p>Discover how to navigate our website and explore the stats. We offer useful calculators and graphs to help you form educated hypotheses on future token burns, price, and rewards.</p>
                          
                        </div>
                      </div>

                      <div className="col-lg-6">
                        
                        <video
                          width="100%"
                          height="350"
                          controls
                          loop
                          style={{ background: '#000', borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
                        >
                          <source src="https://stats.goptgc.com/videos/ufostats.MP4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="tokenNG mb-4  relative overHide pb-0">
                  <div className="shapT1"></div>
                  <div className="shapT2"></div>
                  <div className="p-3">
                    <div className="row align-items-center relative">
                      <div className="col-lg-6">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/videoseries?si=U1K1GKY0BRByIcXm&amp;list=PLqgQvXsvzy94O1YdHD-m6uD493Yb88ENa" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <h3 className="good_times goldFont">Advanced and In-Depth Video Playlist</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        </div>
      </div>

      {/* Modal Styles */}
      <style jsx="true">{`
      `}</style>
    </Modal>
  );
};

export default PTGCModal;
